import React, { useEffect, useState } from "react"
import Sidebar from "../components/sidebar"
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "../axiosInstance";
import * as XLSX from "xlsx";

import Topbar from "../components/topbar";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Pagination from "../components/Pagination";
import { errorMessage } from "../hooks/UserLogs";
export default function AgencyBalance() {
  const [view, setView] = useState(false);
  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [ListAgencies, setListAgencies] = useState([]);
  const [allListAgencies, setAllListAgencies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [firstNameUp, setFirstNameUp] = useState("");
  const [lastNameUp, setLastNameUp] = useState("");
  const [middleNameUp, setMiddleNameUp] = useState("");
  const [profileUp, setprofileUp] = useState("");
  const [addressUp, setAddressUp] = useState("");
  const [phoneUp, setPhoneUp] = useState("");
  const [emailUp, setEmailup] = useState("");
  const [genderUp, setGenderUp] = useState("");
  const [errorForm, setErrorForm] = useState({});
  const [errMsg, seterrMsg] = useState("Une erreure s'est produite!!");
  const [showError, setShowErro] = useState(false);
  const [idUp, setIdUp] = useState(0);
  let defaultBgDate = new Date()
  defaultBgDate.setDate(defaultBgDate.getDate() - 7)
 
  let defaultEndDate = new Date()
  const [beginDate, setBeginDate] = useState(defaultBgDate);
  const [endDate, setEndateDate] = useState(defaultEndDate);
  const [codeAgency, setcodeAgency] = useState("");
  let header =
  {
    'Content-Type': 'application/json'
  };
  const getListWithBalance = async (bgDate, edDate, codeAgency) => {

  }
  const handleClose = () => {
    setErrorForm({});
    setFirstNameUp("")
    setLastNameUp("")
    setMiddleNameUp("")
    setGenderUp("");
    setEmailup("")
    setIdUp(0);
    setPhoneUp("")
    setView(false)

  }
  const viewClose = () => {
    setView(false)
  }
  const viewOpen = () => {
    setView(true)
  }
  const handleCloseError = () => {
    setShowErro(false);
  }

  const viewUpdate = (id, firstName, lastName, middleName, profile, address) => {
    setIdUp(id);
    setAddressUp(address);
    setMiddleNameUp(middleName);
    setLastNameUp(lastName);
    setFirstNameUp(firstName);
    setprofileUp(profile);
    setView(true)
  }
  const getAllListAgencies = async () => {
    let ulr = "/agencies/searche?page=" + currentPage + "&limit=10";

    const response = await axios.get(bUrl + ulr).catch((err) => {

      setIsLoading(false)

      if (err?.response?.status == 401 || err?.response?.status == 403) {
        seterrMsg("Vous n'étes pas autorisé à faire cette opération!!")
        setShowErro(true);
      } else {
        let msg = errMsg + ' ' + err?.response?.status ? (err?.response?.status) : '';
        seterrMsg(msg);
        setShowErro(true);
      }

    });
    if (response) {
      if (response.status == 401) {
        navigate('/backoffice/login');
      }

      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        seterrMsg(msg);
        setShowErro(true);
      }
      else {
        
        setAllListAgencies(response.data.body);
        setTotalPage(response.data.totalPage);
        setCurrentPage(response.data.currentPage);
      }

      setIsLoading(false)


    }
  }
  const dataToExcel = async()=>{
    let bgDateConvert = convertToDate(new Date(beginDate));
    let endDateConvert = convertToDate(new Date(endDate));

    let ulr = "/agencies/searche?page=" + currentPage + "&limit="+10*totalPage+"&begenDate=" + bgDateConvert + "&endDate=" + endDateConvert;
    
    const response = await axios.get(bUrl + ulr).catch((err) => {

      setIsLoading(false)

      if (err?.response?.status == 401 || err?.response?.status == 403) {
        seterrMsg("Vous n'étes pas autorisé à faire cette opération!!")
        setShowErro(true);
      } else {
        let msg = errMsg + ' ' + err?.response?.status ? (err?.response?.status) : '';
        seterrMsg(msg);
        setShowErro(true);
      }

    });
    if (response) {
      if (response.status == 401) {
        navigate('/backoffice/login');
      }

      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        seterrMsg(msg);
        setShowErro(true);
      }
      else {
        
        const filterListAgent=response.data.body.map(({name,code,accounting})=>({
          nom:name,
          phone: code,
          balance: accounting?.balance,
        }))
        const ws = XLSX.utils.json_to_sheet(filterListAgent);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Marchand");
        XLSX.writeFile(wb, "Marchand_Balance.xlsx");
      }

      setIsLoading(false)


    }
    
    
  }
  const updateForm = () => { }

  const bUrl = process.env.REACT_APP_B_URL;

  const { id } = useParams();
  const convertToDate = (resultDate) => {
    const yyyy = resultDate.getFullYear();
    let mm = resultDate.getMonth(); // Months start at 0!
    let dd = resultDate.getDate();
    mm = mm + 1;
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return yyyy + '-' + mm + '-' + dd + 'T00:00:00.000Z';
  }
  const navigate = useNavigate();
  const getListAgencies = async (bgDate, edDate, codeAgency) => {
    setBeginDate(new Date(bgDate));
    
    setEndateDate(new Date(edDate));
    setcodeAgency(codeAgency);
    let bgDateConvert = convertToDate(new Date(bgDate));
    let endDateConvert = convertToDate(new Date(edDate));
   
    let ulr = "/agencies/searche?page=" + currentPage + "&limit=10&begenDate=" + bgDateConvert + "&endDate=" + endDateConvert;
    if (codeAgency != '') {
      ulr += "&code=" + codeAgency;
    }
    

    const response = await axios.get(bUrl + ulr).catch((err) => {
      
      setIsLoading(false)

    });

    if (response) {
      if (response.status == 401) {
        navigate('/backoffice/login');
      }

      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        seterrMsg(msg);
        setShowErro(true);
      } else {
        setListAgencies(response.data.body);
        setTotalPage(response.data.totalPage);
        setCurrentPage(response.data.currentPage);
      }

      setIsLoading(false);
    }
  }
  const updateCustomer = () => {
    let error = {};
    let isvalid = true;

    if (firstNameUp == "") {
      error.firstNameUp = "Field is required!";
      isvalid = false;
    }
    if (lastNameUp == "") {
      error.lastNameUp = "Field is required!";
      isvalid = false;
    }

    if (addressUp == "") {
      error.addressUp = "Field is required!";
      isvalid = false;
    }
    if (profileUp == "") {
      error.profileUp = "Field is required!";
      isvalid = false;
    }

    setErrorForm(error);
    if (isvalid) {
      setIsLoading(true);
      axios.put(bUrl + "/customer-wallet/update-by-staff",

        //birthDay: birthDay,
        {
          "id": idUp,
          "firstName": firstNameUp,
          "lastName": lastNameUp,
          "middleName": middleNameUp,
          "profile": profileUp,
          "address": addressUp,
        }


        , { header: header })
        .then(function (response) {
          //getDayOffDayEmmp(idEmp);
          setIsLoading(false)

          handleClose()
          if (response?.data?.isError) {
            const msg = errorMessage(response?.data?.code)
            seterrMsg(msg);
            setShowErro(true);
          }
          else {
            getListAgencies(email, phone, code);
          }

        })
        .catch(function (err) {

          setIsLoading(false)

          if (err?.response?.status == 401 || err?.response?.status == 403) {
            seterrMsg("Vous n'étes pas autorisé à faire cette opération!!")
            setShowErro(true);
          } else {
            let msg = errMsg + ' ' + err?.response?.status ? (err?.response?.status) : '';
            seterrMsg(msg);
            setShowErro(true);
          }

        });
    }
  }

  const postCutomers = async () => {

  }
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }
  useEffect(() => {
    if (sessionStorage.getItem("name") === '' || sessionStorage.getItem("name") === null) {
      //console.log("----------GO GO GO ------------")
      navigate('/backoffice/login');
    }
    getAllListAgencies();
    getListAgencies(beginDate, endDate, codeAgency);
  }, [currentPage])

  return (
    <div className="App">
      <div className="">
        <Sidebar />
        <section className="home ">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                <div><p className='fw-bold'>Crédit agence et solde disponible</p></div>
                <div><Topbar /></div>
              </div>
              <div className="table-content mt-3 p-3">
                <div className="d-flex justify-content-around">
                  <div className="form-group text">
                    <label htmlFor="exampleInputEmail1">Début</label>
                    <input type="Date" value={beginDate.toLocaleDateString('en-CA')} onChange={(e) => getListAgencies(e.target.value, endDate, codeAgency)} className="form-control" id="exampleInputEmail1" />
                  </div>
                  <div className="form-group text">
                    <label htmlFor="phone">Fin</label>
                    <input type="Date" value={endDate.toLocaleDateString('en-CA')} onChange={(e) => getListAgencies(beginDate, e.target.value, codeAgency)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                  </div>
                  <div className="form-group text">
                    <label htmlFor="code">Agence</label>
                    <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" value={codeAgency} onChange={(e) => getListAgencies(beginDate, endDate, e.target.value)}>
                      <option value="">Sélectionnez Agent</option>
                      {allListAgencies != null ? allListAgencies.length > 0 ? allListAgencies.map((a, i) => {
                        return <option value={a.code} key={i}>{a.code}</option>
                      }
                      ) : '' : ''}

                    </select>                  </div>
                </div>
              </div>
              <div className="table-content mt-3 p-3">

              <div className="d-flex flex-row-reverse">
                <div>
                  <span onClick={() => dataToExcel()} className="clickable">
                    <i className='bx bx-printer bx-sm'></i>
                  </span>
                </div>
              </div>
                
                {/* <a href="/Home/Create" className="btn btn-primary mb-1"> </a> */}
                <div className="table-responsive-xl">
                  {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
                    <table className="table text">
                      <thead>
                        <tr>

                          <th scope="col">Id</th>
                          <th scope="col">Nom</th>
                          <th scope="col">code</th>
                          <th scope="col">Solde</th>

                          <th></th>
                          <th></th>

                        </tr>
                      </thead>

                      <tbody>
                        {ListAgencies != null ? ListAgencies.length > 0 ? ListAgencies.map((a, i) => {
                          return <tr key={i}>
                            <td>{i}</td>
                            <td>{a.name}</td>
                            <td>{a.code}</td>
                            {a.accounting !== null ?
                              <td>{a.accounting.balance}</td> : ''
                            }

                          </tr>
                        }) : <tr></tr> : ''}
                      </tbody>

                    </table>
                  }
                </div>
                <Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />
              </div>

            </div>
          </div>
        </section>
      </div>
      <Modal show={view} onHide={handleClose} className="">
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Agency</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="form-group mb-2">
              <input type="text" placeholder="Prénom" name="firstname" className='form-control ' value={firstNameUp} onChange={(e) => setFirstNameUp(e.target.value)} />
              {errorForm.firstNameUp != "" && <p style={{ color: 'red' }}>{errorForm.firstNameUp}</p>}
            </div>
            <div className="form-group mb-2">
              <input type="text" placeholder="Deuxième Nom" name="middlename" className='form-control ' value={middleNameUp} onChange={(e) => setMiddleNameUp(e.target.value)} />
              {errorForm.middleNameUp != "" && <p style={{ color: 'red' }}>{errorForm.middleNameUp}</p>}
            </div>
            <div className="form-group mb-2">
              <input type="text" placeholder="Nom" name="lastname" className='form-control ' value={lastNameUp} onChange={(e) => setLastNameUp(e.target.value)} />
              {errorForm.lastNameUp != "" && <p style={{ color: 'red' }}>{errorForm.lastNameUp}</p>}
            </div>
            <div className="form-group mb-2">
              <input type="text" placeholder="Adresse" name="name" className='form-control ' value={addressUp} onChange={(e) => setAddressUp(e.target.value)} />
              {errorForm.addressUp != "" && <p style={{ color: 'red' }}>{errorForm.addressUp}</p>}
            </div>

            <div className="form-group">
              <select className="form-control" id="exampleFormControlSelect1" placeholder='Gender' onChange={(e) => setprofileUp(e.target.value)} value={profileUp}>
                <option >Sélectionner profil</option>

                <option value={'CUSTOMER'} selected={profileUp == "CUSTOMER"} >Customer</option>
                <option value={'AGENT'} selected={profileUp == "AGENT"} >Marchand</option>

              </select>
              {errorForm.profileUp != "" && <p style={{ color: 'red' }}>{errorForm.profileUp}</p>}
            </div>





          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {isLoading ?
            <img src='../Custom.svg' width="30%" />
            :
            <Button variant="primary" onClick={updateCustomer}>
              Modifier
            </Button>

          }
        </Modal.Footer>
      </Modal>

      {/* =============================================error=============================== */}
      <Modal show={showError} onHide={handleCloseError} className="">
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title>ERROR</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseError}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}